<template>
  <div class="select_dialog_embed">
    <div class="role_settings_embed_msg">
      <div class="select_dialog_embed_box" :class="{'select_dialog_embed_box_490': showType === 'removeBinding'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--新增/编辑角色-->
          <div v-if="showType === 'addRole' || showType === 'modifyRole'" class="select_dialog_embed_box_handle">
            <div>
              <label>名称：</label>
              <input type="text" title="名称" maxlength="20"
                     v-model="addModifyRole"
                     @keyup.enter="saveRole()">
            </div>
          </div>

          <!--删除角色-->
          <div v-if="showType === 'delRole'" class="select_dialog_embed_box_handle">
            <div style="margin-bottom: 40px">
              请确定是否要删除当前角色，删除后数据将不可进行恢复！
            </div>
          </div>

          <!--停用角色-->
          <div v-if="showType === 'disableRole'" class="select_dialog_embed_box_handle" style="width: 95%">
            <div style="margin-bottom: 40px">
              请确定是否要停用当前角色，停用后角色关联的用户将禁止登录！
            </div>
          </div>

          <!--启用角色-->
          <div v-if="showType === 'enableRole'" class="select_dialog_embed_box_handle" style="width: 95%">
            <div style="margin-bottom: 40px">
              请确定是否要启用当前角色，启用后角色关联的用户可进行正常登录！
            </div>
          </div>

          <!--配置权限-->
          <div v-if="showType === 'configurePermissions'" class="select_dialog_embed_box_handle configurePermission" style="width: 95%; border: 2px inset;">
            <div>
              <el-tree
                :data="permissions"
                show-checkbox
                node-key="id"
                ref="tree"
                :default-checked-keys="defaultChecked"
                :props="defaultProps">
              </el-tree>
              <!--:default-checked-keys="[id]" 默认选中的id-->
            </div>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
    export default {
        name: 'role-settings-embed-msg',
      /**
       *  title：  头部名
       *  showType: addRole=新增角色  modifyRole=编辑角色  enableRole=启用角色  disableRole=停用用户  delRole=删除角色  configurePermissions=配置权限
       *  roleMsg: 角色信息
       * */
      props: ['title', 'showType', 'roleMsg'],
      components: {MsgDialog},
      data() {
        return {
          addModifyRole: '', // 新增/编辑角色
         /* permissions: [{
            id: 1,
            name: '一级 1',
            children: [{
              id: 4,
              name: '二级 1-1',
              children: [{
                id: 9,
                name: '三级 1-1-1'
              }, {
                id: 10,
                name: '三级 1-1-2'
              }, {
                id: 11,
                name: '三级 1-1-3'
              }, {
                id: 12,
                name: '三级 1-1-4'
              }, {
                id: 13,
                name: '三级 1-1-5'
              }, {
                id: 14,
                name: '三级 1-1-6'
              }]
            }]
          }, {
            id: 2,
            name: '一级 2',
            children: [{
              id: 5,
              name: '二级 2-1'
            }, {
              id: 6,
              name: '二级 2-2'
            }]
          }, {
            id: 3,
            name: '一级 3',
            children: [{
              id: 7,
              name: '二级 3-1'
            }, {
              id: 8,
              name: '二级 3-2'
            }]
          }], */
          permissions: [], // 权限
          defaultProps: {
            children: 'children',
            label: 'name'
          }, // 显示的标签
          defaultChecked: [], // 默认选择到的值id
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '', // 信息框内容
          time: 3, // 倒计时时间
          timer: null // 计时器
        }
      },
      methods: {
        // 获取权限列表数据和角色已选择的权限数据--树结构
        getRoleCompetenceData() {
          this.defaultChecked = []; // 默认选择清空
          this.$axios.get(this.Global.getRoleCompetenceData(this.roleMsg.Id)).then((res) => {
            if (!res.data.errorMsg.length) {
              if (res.data.resData) {
                this.permissions = this.createTreeData(res.data.resData, '3');
                for (let i in res.data.resData) {
                  if (res.data.resData[i].check) {
                    this.defaultChecked.push(res.data.resData[i].id);
                  }
                }
              }
            }
          });
        },

        /*
        * 传入的数组有id和父节点pid字段，通过它们的关联构造成一棵或多棵树结构
        * @param nodes 集合
        *  @param treeRootId 根节点的id
        */
        createTreeData(nodes, treeRootPid) {
          let groups = {};
          // 按父节点将节点分组
          for (let i in nodes) {
            if (!groups[nodes[i].pId]) {
              groups[nodes[i].pId] = [];
            }

            groups[nodes[i].pId].push(nodes[i]);

            if (treeRootPid && treeRootPid === nodes[i].id) {
              treeRootPid = nodes[i].pId;
            }
          }

          let rootNodes = groups[treeRootPid];
          groups[treeRootPid] = null; // [SAFEGUARD]防止自为父节点或互为父节点（有环图结构）导致的死循环

          function traverseTreeNodeGroup(treeNodeGroup) {
            for (let i in treeNodeGroup) {
              var node = treeNodeGroup[i];
              if (groups[node.id]) {
                node.children = groups[node.id];
                groups[node.id] = null; // [SAFEGUARD]防止自为父节点或互为父节点（有环图结构）导致的死循环
                traverseTreeNodeGroup(node.children);
              }
            }
          }

          traverseTreeNodeGroup(rootNodes);

          // this.permissions = rootNodes;
          console.log(rootNodes);
          return rootNodes
        },

        // 获取选中值
        getCheckedKeys() {
          console.log(this.$refs.tree.getCheckedKeys());
          this.saveRoleCompetenceData(this.$refs.tree.getCheckedKeys());
        },

        // 设置角色权限--保存角色设置的参数
        saveRoleCompetenceData(ids) {
          const params = {
            roleId: this.roleMsg.Id,
            competenceIds: ids
          };
          this.$axios.post(this.Global.saveRoleCompetenceData, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 保存角色
        saveRole() {
          if (!this.addModifyRole) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入角色名称';
          } else {
            let params;
            if (this.showType === 'addRole') {
              params = {
                Name: this.addModifyRole,
                SysType: '3'
              };
            } else {
              params = {
                Id: this.roleMsg.Id,
                Name: this.addModifyRole,
                SysType: '3'
              };
            }
            this.$axios.post(this.Global.saveRole, params).then((res) => {
              if (!res.data.errorMsg.length) {
                this.cancelBtn(true);
              } else {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = res.data.errorMsg;
              }
            });
          }
        },

        // 修改角色状态
        changeRoleStatus() {
          let status;
          if (this.showType === 'enableRole') {
            status = 1;
          } else {
            status = 2;
          }
          this.$axios.get(this.Global.changeRoleStatus(this.roleMsg.Id, status)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 删除角色
        deleteRole() {
          this.$axios.get(this.Global.deleteRole(this.roleMsg.Id)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 提交按钮
        submitBtn() {
          if (this.showType === 'addRole' || this.showType === 'modifyRole') { // 保存角色
            this.saveRole();
          } else if (this.showType === 'enableRole' || this.showType === 'disableRole') { // 修改角色状态
            this.changeRoleStatus();
          } else if (this.showType === 'delRole') { // 删除角色
            this.deleteRole();
          } else if (this.showType === 'configurePermissions') {
            this.getCheckedKeys();
          } else {
            this.cancelBtn(false);
          }

          // 计时器
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isMsg = false;
              clearInterval(self.timer);
            }
          }, 1000);
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, handleType: type});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      },
      created() {
        if (this.roleMsg) {
          this.addModifyRole = this.roleMsg.Name;
        }

        if (this.showType === 'configurePermissions') {
          this.getRoleCompetenceData();
        }
      }
    }
</script>

<style lang="scss" scoped>
@import "../../../assets/css/home-view";
  .role_settings_embed_msg {
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/role-settings-embed-msg.vue